import React from 'react';

export const HeaderPublic = ({ settings: _settings }: { settings?: { withoutSearch?: boolean; withPrint?: boolean } }) => {
  const imagePath = process.env.PUBLIC_URL;
  const dhsUrl = 'https://dhs.lacounty.gov/';
  const laCountyUrl = 'https://lacounty.gov/';

  return (
    <header className="z-20 mb-2 w-full flex-shrink-0 px-0 pt-1 sm:px-1 lg:px-1 xl:px-2">
      <div className="app-header-shell">
        <div className="app-header-brand-rail">
          <div className="flex min-w-0 items-center">
            <a href={dhsUrl} target="_blank" rel="noreferrer" className="app-header-brand-logos">
              <img
                src={`${imagePath}/dhs-logo.svg`}
                alt="Los Angeles County Department of Health Services"
                className="h-6 w-auto"
              />
            </a>
          </div>
          <a
            href={laCountyUrl}
            target="_blank"
            rel="noreferrer"
            className="opacity-75 transition hover:opacity-100"
          >
            <img
              src={`${imagePath}/lacountyseal.png`}
              alt="County of Los Angeles seal"
              className="h-5 w-5 object-contain"
            />
          </a>
        </div>

        <div className="flex items-center px-3 py-1.5 sm:px-4">
          <div className="flex min-w-0 items-center gap-2.5" aria-label="Diversion Database">
            <img
              src={`${imagePath}/logoODR.png`}
              alt="Office of Diversion and Reentry"
              className="h-7 w-auto object-contain"
            />
            <div className="text-base font-bold text-gray-900 leading-none tracking-tight">
              Diversion Database
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
